"use client";

import React from "react";
import { useRouter } from "next/navigation";
import Image from "next/image";

const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("vi-VN", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

export default function NewsItem({ news, index, isRespon = false }) {
  const router = useRouter();

  const handleClick = () => {
    router.push(`/tin-tuc/${news.id}`);
  };

  const title = news.title || "";

  return (
    <div
      className="w-full h-full relative cursor-pointer"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleClick();
        }
      }}
    >
      <div
        className={`overflow-hidden ${
          index === 0 ? "h-full" : "max-h-[300px]"
        }`}
      >
        {index === 0 ? (
          <div className="relative w-full h-full">
            <img
              loading="lazy"
              src={news.thumbnail || "/images/default.jpg"}
              className={`object-cover w-full h-full hover:scale-125 transition duration-500 rounded ${
                isRespon ? "h-[200px] sm:h-[300px]" : ""
              }`}
              alt={title}
            />
          </div>
        ) : (
          <img
            src={news.thumbnail || "/images/default.jpg"}
            className={`object-cover w-full h-full hover:scale-125 transition duration-500 rounded ${
              isRespon ? "h-[200px] sm:h-[300px]" : ""
            }`}
            alt={title}
            width={400}
            height={300}
          />
        )}
      </div>
      <div
        className={
          index === 0 ? "absolute bottom-0 left-0 p-6 text-white" : "relative"
        }
      >
        <div className="flex items-center gap-x-2 mt-6 text-xs">
          <img src="/svg/clock.svg" />
          <span className="font-light text-[#06B6D4]">
            {formatDate(news.createdAt)}
          </span>
        </div>
        <div
          className={`mt-2 font-semibold ${index === 0 ? "xl:text-3xl" : ""} ${
            isRespon ? "text-xl sm:text-base" : ""
          }`}
        >
          {title}
        </div>
      </div>
    </div>
  );
}
